import BarAndPieChartContainer from "components/StatisticsCutomComponents/BarAndPieChartContainer";
import NoFoodIcon from "assets/Images/statistics/nofood.png";
import useControlParams from "hooks/useControlParams";
import { useGetStats } from "pages/Dashboard/dashboardQueries";
import apiStatsKey from "constants/apiKeys";
import { getChangeKey } from "./InflowTransactions";
import paramsKey from "constants/paramsKey";

export default function NonFoodExpendituresSection() {
  const { availableParams, getParamValue } = useControlParams();
  const { data: NonFoodData } = useGetStats(
    availableParams(),
    apiStatsKey.nonFoodExpenditures
  );

  const changedKey = getChangeKey(getParamValue(paramsKey.filterKey));
  return (
    <BarAndPieChartContainer
      graphHeadLine={{ icon: NoFoodIcon, heading: "Non-food Expenditures" }}
      barGraphData={{
        bgcolor: "#7E65C3",
        data:
          changedKey === "hour" // getting different response structur from BE on daily filters
            ? NonFoodData?.data?.bars?.[0]?.transactions
            : NonFoodData?.data?.bars,
        xdatakey: changedKey,
        ydatakey: "amount",
      }}
      pieGraphData={{
        colorOfPiechart: "#7E65C3",
        data: NonFoodData?.data?.pie || [],
        datakey: "percentages",
        namekey: "name",
      }}
      dxY={-40}
    />
  );
}
